import { h, render } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import clsx from 'clsx';
import ArrowLeft from '../utils/icon/arrow-left.svg';
import ArrowRight from '../utils/icon/arrow-right.svg';
import ProductCard from '../product-card/product-card';
import { getCollectionProducts } from '../utils/storefront/get-products';
import { waitForElm } from '../utils/helpers';

export default (element, data) => {
  const ProductCarousel = ({
    title,
    description,
    ctaCopy,
    ctaLink,
    encodedCollectionId,
    sectionId,
  }) => {
    const [products, setProducts] = useState([]);

    useEffect(() => {
      const getProducts = async () => {
        const collectionProducts = await getCollectionProducts(
          encodedCollectionId,
          12,
        );
        setProducts(collectionProducts?.data?.node?.products?.edges);
      };
      getProducts();
    }, []);

    const initReviewWidget = () => {
      waitForElm('.yotpo.bottomLine').then(() => {
        if (window.yotpo?.initWidgets) {

          if (window.yotpo.initialized) {
            window.yotpo.refreshWidgets()
          } else window.yotpo.initWidgets();

          let attempts = 0;
          const interval = setInterval(() => {
            if (
              document.querySelectorAll('.yotpo-bottomline a').length > 0 ||
              attempts > 1000
            ) {
              clearInterval(interval);
              window.yotpo.widgets.map((widget) => {
                const widgetNodeStarsText = widget.element.querySelector(
                  '.yotpo-bottomline a',
                );
                if (widgetNodeStarsText) {
                  widgetNodeStarsText.remove();
                }
                return '';
              });
            }
            attempts += 1;
          }, 100);
        }
      });
    }
    
    return (
      <div
        id={`Recommendations--${sectionId}`}
        className="py-10 laptop:py-20 relative"
      >
        <div className="px-5 laptop:px-10 mb-[22px] laptop:mb-[32px] leading-[1] text-[0]">
          {title && <h2 className="subheading-h2 mb-0.5">{title}</h2>}
          {description && (
            <div
              className="text-charcoal font-16 laptop:max-w-[500px] mb-3 laptop:mb-3.5 leadding-[1.5]"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
          )}
          {ctaCopy && ctaLink && (
            <a
              className="text-black cta-small uppercase underline leading-[1]"
              href={ctaLink}
            >
              {ctaCopy}
            </a>
          )}
        </div>
        <div className='[&_.yotpo-stars+a]:hidden'>
          <div
            className={clsx(
              'item-center justify-between absolute h-[35px] gap-2.5 flex left-5 bottom-10 laptop:left-auto laptop:right-10 laptop:bottom-auto laptop:top-20 z-[5]',
            )}
          >
            <button className="swiper-button-prev !static !bg-transparent !m-0 !w-[35px] !h-[35px] !text-black after:!content-[none] navigation-arrow">
              <ArrowLeft />
            </button>
            <button className="swiper-button-next !static !bg-transparent !m-0 !w-[35px] !h-[35px] !text-black after:!content-[none] navigation-arrow">
              <ArrowRight />
            </button>
          </div>
          <Swiper
            slidesPerView={1.3}
            spaceBetween={10}
            modules={[Navigation]}
            onAfterInit={initReviewWidget}
            navigation={{
              nextEl: `#Recommendations--${sectionId} .swiper-button-next`,
              prevEl: `#Recommendations--${sectionId} .swiper-button-prev`,
            }}
            className="!px-5 laptop:!px-10 !pb-[57px] laptop:!pb-0"
            breakpoints={{
              1024: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }}
          >
            {products.map((product, index) => (
              <SwiperSlide className="!h-auto" key={`product-card-${index}`}>
                <ProductCard
                  customClass="h-full"
                  currentProduct={product.node}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    );
  };
  const init = () => {
    render(<ProductCarousel {...data} />, element);
  };

  init();
};
